import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { makeResetCache, fetchApi, notifyResponse, notifyError } from 'gossamer-front-end';
import {
  AdminInstitutionGroupDeactivateRequest,
  InstitutionGroup,
  InstitutionGroupEvent,
  InstitutionGroupMember,
} from 'cb-model';

export interface GroupDeactivateButtonProps {
  institutionGroupId: number;
}

export const GroupDeactivateButton = (props: GroupDeactivateButtonProps): React.JSX.Element => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const resetCache = makeResetCache(dispatch);
  const isProcessing = React.useRef(false);

  const handleDelete = async () => {
    const check = confirm(
      'This removes any members and/or events from the group and then removes the group itself. It does not ' +
        'unbook any bookings created automatically. Are you sure? This action cannot be reversed.',
    );
    if (!check) {
      return;
    }
    if (isProcessing.current) {
      return;
    }
    try {
      isProcessing.current = true;
      const resp = await fetchApi('POST', `/main/institution-group-deactivate`, {
        institutionGroupId: props.institutionGroupId,
      } as AdminInstitutionGroupDeactivateRequest);
      resetCache(InstitutionGroup.id);
      resetCache(InstitutionGroupEvent.id);
      resetCache(InstitutionGroupMember.id);
      notifyResponse(resp);
      navigate('/admin/institution-group/search');
    } catch (e) {
      notifyError(e, 'An error occurred while deactivating this institution group');
    }
    isProcessing.current = false;
  };

  return (
    <Button type="button" size="sm" variant="danger" onClick={handleDelete}>
      Deactivate
    </Button>
  );
};
